import { Chip } from '@mui/material';
import { getBookingStatusChipSx } from 'utils/bookingStatusChipStyles';

type BookingStatusChipProps = {
  status?: string | null;
  label?: string | null;
};

export const BookingStatusChip = ({ status, label }: BookingStatusChipProps) => {
  const resolvedStatus = status?.trim() ?? '';
  const resolvedLabel = label?.trim() || resolvedStatus;

  if (!resolvedStatus && !resolvedLabel) {
    return null;
  }

  return (
    <Chip
      label={resolvedLabel || '—'}
      size="small"
      variant="outlined"
      sx={{
        fontWeight: 600,
        fontSize: '0.75rem',
        height: 26,
        flexShrink: 0,
        ...(resolvedStatus ? getBookingStatusChipSx(resolvedStatus) : {}),
      }}
    />
  );
};

export default BookingStatusChip;
